// This is the parent component of a modal: ModalAdminpayments

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GenericModal from "./GenericModal";
import Navbar from "./Navbar";
import PayoutViewModal from "./PayoutViewModal";
import { deleteCharity } from "./redux/slices/charitiesThunks";
import { fetchPayoutRequests } from "./redux/slices/payoutRequestsThunk";

export default function AdminPayoutRequests() {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedCharity, setselectedCharity] = useState(null);
  const [selectedRequest, setselectedRequest] = useState(null);
  const [openViewModal, setopenViewModal] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const charities = useSelector((state) => state.charities.items);
  const [tableData, setTableData] = useState([]);

  const openModal = () => setIsModalOpen(true);
  const openEditModal = () => setIsEditModalOpen(true);
  const closeModal = async () => {
    setIsModalOpen(false);
  };

  const editClick = (item) => {
    setselectedCharity(item);
    openEditModal();
  };
  const deleteClick = (item) => {
    setselectedCharity(item);
    setIsDeleteModalOpen(true);
  };
  const viewClick = (item) => {
    setselectedRequest(item);
    setopenViewModal(true);
  };
  const onDeleteClick = async () => {
    await dispatch(deleteCharity(selectedCharity?._id));
    setIsDeleteModalOpen(false);
  };
  const tableHeaders = [
    { label: "Request ID", flex: 1 },
    { label: "Date", flex: 1 },
    { label: "Member", flex: 1 },
    { label: "Type", flex: 1 },
    { label: "Status", flex: 1 },
    { label: "Amount", flex: 1 },
    { label: "Action" },
  ];

  const tableColumns = [
    { key: "requestId", flex: 1 },
    { key: "date", flex: 1 },
    { key: "member", flex: 1 },
    { key: "type", flex: 1 },
    { key: "payout_status", flex: 1 },
    { key: "amount", flex: 1 },
    { key: "action" },
  ];

  useEffect(() => {
    dispatch(fetchPayoutRequests("me"))
      .unwrap()
      .then((data) => {
        // Transform each payout request into table row format
        const rows = data?.requests.map((item) => ({
          requestId: "R" + item._id.slice(-6),
          date: new Date(item.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
          member: `${item.member_id?.email_address || ""}`,
          type: item.member_id?.member_type,
          payout_status: item.status,
          amount: `£${item.amount}`,
          _id: item._id,
          item: item,
        }));
        setTableData(rows);
      })
      .catch((err) => {
        console.error("❌ Error fetching payout requests:", err);
      });
  }, [dispatch, openViewModal]);

  return (
    <RootWrapperAdminpayments>
      <Navbar />
      <Dashboard>
        <Wrapper>
          <Left_0001>
            <PRTNR.SidebarNav />
          </Left_0001>
          <Right>
            <DashboardHeader>
              <Frame1462>
                <WelcomeJames>Payout requests</WelcomeJames>
              </Frame1462>
            </DashboardHeader>
            <ContentBox>
              <TableTitle>
                <Frame1431>
                  <Title>All</Title>
                </Frame1431>
                <Frame1432>
                  <GFieldsStacked>
                    <GFieldsStacked_0001>
                      <PRTNR.Input
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </GFieldsStacked_0001>
                  </GFieldsStacked>
                </Frame1432>
              </TableTitle>
              <PRTNR.TableComponent
                data={tableData}
                tableColumn={tableColumns}
                tableHeader={tableHeaders}
                editClick={editClick}
                viewClick={viewClick}
                deleteClick={deleteClick}
              />
            </ContentBox>
          </Right>
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Section_0001>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0001>
        </Section>
      </Footer>

      <GenericModal
        isOpen={openViewModal}
        onClose={() => setopenViewModal(!openViewModal)}
      >
        <PayoutViewModal
          isOpen={openViewModal}
          onClose={() => {
            setopenViewModal(false);
          }}
          selectedRequest={selectedRequest}
        />
      </GenericModal>
    </RootWrapperAdminpayments>
  );
}

const RootWrapperAdminpayments = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 32px 0px;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 298px;
  box-sizing: border-box;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 878px;
  box-sizing: border-box;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 692px;
  box-sizing: border-box;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: center;
`;

const ContentBox = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const TableTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1431 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Title = styled.span`
  color: var(--Color-Text-Text, #212543);

  /* P1 */
  font-family: Montserrat;
  font-size: var(--Fonts-P1, 20px);
  font-style: normal;
  font-weight: 700;
  line-height: 160%; /* 32px */
`;

const Frame1432 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 782px;
  box-sizing: border-box;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 4px;
  box-sizing: border-box;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
